import {Component} from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Form from '-/components/fields/Form';
import Button from '-/components/general/Button';
import {rem} from '-/styles/utils';

const styles = () => ({
    button: {
        margin: `${rem(50)} auto ${rem(40)}`
    }
});

class Modal extends Component {
    static propTypes = {
        onClick: PropTypes.func,
        buttonText: PropTypes.string,
        showButton: PropTypes.bool
    };

    static defaultProps = {
        onClick: () => {},
        buttonText: 'That\'s me!',
        showButton: true
    };

    constructor(props) {
        super(props);

        this.state = {
            height: 0,
            btnHeight: 0
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.onClick();
    }

    render() {
        const {children, buttonText, showButton, classes = {}} = this.props;

        return (
            <Form onSubmit={this.handleSubmit}>
                {children}
                {showButton && (
                    <Button tag="a" btnStyle="alternate" ref="button" className={classes.button} onClick={this.handleSubmit}>
                        {buttonText}
                    </Button>
                )}
            </Form>
        );
    }
}

export default injectSheet(styles)(Modal);
